import flagItemsStoreUpdate from 'owa-mail-actions/lib/triage/flagItemsStoreUpdate';
import mailStore from 'owa-mail-store/lib/store/Store';
import { mutator } from 'satcheljs';
export default mutator(flagItemsStoreUpdate, function (actionMessage) {
    var itemContexts = actionMessage.itemContexts;
    // Update flag status on items
    itemContexts.forEach(function (itemContext) {
        var item = mailStore.items.get(itemContext.itemId);
        item.Flag = { FlagStatus: actionMessage.flagStatusToSet };
    });
});
//# sourceMappingURL=flagItemsStoreUpdateMutator.js.map